// routes/courses/not-found.tsx
import BreadcrumbSection from "~/layout/public/bread-crumbs/bread-crumb-section";
import { isRouteErrorResponse, useParams, useRouteError } from "react-router";
import NotFoundCourseSection from "~/components/pages/special-pages/not-found-course-section";
import NotFoundCoursesSection from "~/components/pages/special-pages/not-found-courses-section";
// export async function loader() {
//   throw new Response("Not Found", { status: 404 });
// }


export default function NotFound() {
     const params = useParams();
  const err = useRouteError();


  // Decide which variant to show by presence of :courseId
  const isCourseDetail = Boolean(params.courseId);
    const title = isCourseDetail ? "Unable to find course" : "Unable to find courses";
  const text = isCourseDetail
    ? "There appears to be an issue with the course details. Please try again later."
    : "There appears to be an issue with the course listings. Please try again later.";

    return (
        <>
            <main id="main">
                <BreadcrumbSection title={title} text={text} />
      {isCourseDetail ? <NotFoundCourseSection /> : <NotFoundCoursesSection />}
            </main>
        </>
    );
}